/*
  FBT Add-to-Cart → quantity stepper controller
  ----------------------------------------------
  - Tapping "Add to Cart" adds 1 of the variant via /cart/add.js, then the
    button morphs into a − / qty / + stepper showing the live cart quantity.
  - − / + update the cart line via /cart/change.js. Reaching 0 removes the
    line and reverts to the "Add to Cart" button.
  - All [data-fbt-atc] wrappers for the same variant stay in sync, so the
    desktop card and the mobile block always show the same quantity.

  One document-wide controller; guarded so multiple section includes are safe.
*/
(function () {
  if (window.__fbtAtcInit) return;
  window.__fbtAtcInit = true;

  var ROOT = '[data-fbt-atc]';

  function key(id) {
    return String(id);
  }

  function wrappers() {
    return Array.prototype.slice.call(document.querySelectorAll(ROOT));
  }

  function forVariant(variantId, fn) {
    var k = key(variantId);
    wrappers().forEach(function (w) {
      if (key(w.getAttribute('data-variant-id')) === k) fn(w);
    });
  }

  function setBusy(variantId, on) {
    forVariant(variantId, function (w) {
      var stepper = w.querySelector('[data-fbt-atc-stepper]');
      if (stepper) stepper.classList.toggle('is-busy', !!on);
      var add = w.querySelector('[data-fbt-atc-add]');
      if (add) add.disabled = !!on || add.hasAttribute('data-sold-out');
    });
  }

  function setQty(variantId, qty) {
    forVariant(variantId, function (w) {
      var val = w.querySelector('[data-fbt-qty-val]');
      if (qty > 0) {
        w.classList.add('is-added');
        if (val) val.textContent = qty;
      } else {
        w.classList.remove('is-added');
        if (val) val.textContent = '1';
      }
    });
  }

  function applyCart(cart) {
    var map = {};
    (cart.items || []).forEach(function (it) {
      map[key(it.variant_id)] = it.quantity;
    });
    wrappers().forEach(function (w) {
      var k = key(w.getAttribute('data-variant-id'));
      setQty(k, map[k] || 0);
    });
    document.dispatchEvent(new CustomEvent('fbt:cart:updated', { detail: { cart: cart } }));
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function add(variantId) {
    setBusy(variantId, true);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(getCart)
      .then(applyCart)
      .catch(function () {})
      .then(function () {
        setBusy(variantId, false);
      });
  }

  function change(variantId, quantity) {
    setBusy(variantId, true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (r) {
        return r.json();
      })
      .then(applyCart)
      .catch(function () {})
      .then(function () {
        setBusy(variantId, false);
      });
  }

  function currentQty(wrapper) {
    var val = wrapper.querySelector('[data-fbt-qty-val]');
    return (val && parseInt(val.textContent, 10)) || 0;
  }

  // Add to Cart (intercept the product form submit).
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form') : null;
    if (!form) return;
    var w = form.closest(ROOT);
    if (!w) return;
    e.preventDefault();
    add(w.getAttribute('data-variant-id'));
  });

  // − / + stepper controls.
  document.addEventListener('click', function (e) {
    var inc = e.target.closest && e.target.closest('[data-fbt-qty-inc]');
    var dec = e.target.closest && e.target.closest('[data-fbt-qty-dec]');
    var btn = inc || dec;
    if (!btn) return;
    var w = btn.closest(ROOT);
    if (!w) return;
    var id = w.getAttribute('data-variant-id');
    var qty = currentQty(w);
    change(id, inc ? qty + 1 : Math.max(0, qty - 1));
  });

  // Reflect existing cart contents on load.
  function init() {
    if (!wrappers().length) return;
    getCart().then(applyCart).catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
